/**
 * ==============================================================================
 * DATA LAYER (DL) - DÍA DE PICNIC
 * Se encarga de la comunicación directa con la API (EndPoints de PicnicController).
 * ==============================================================================
 */

const PrepareScreenForPicnicApiCall = async () => {
    try {
        const responseFromBackend = await fetch(`${process.env.REACT_APP_API_URL}picnic/prepare`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (!responseFromBackend.ok) {
            const errorData = await responseFromBackend.json();
            return { success: false, message: errorData.message || 'Error al preparar la pantalla para Picnic Day.' };
        }
        
        const data = await responseFromBackend.json();
        return { success: true, data: data };
    } catch (networkError) {
        return { success: false, message: 'Error de red al intentar conectar con el servidor.' };
    }
};

const StartPicnicMatchApiCall = async (durationInSeconds, settingsObjectAsJson) => {
    try {
        const payloadToSend = {
            durationSeconds: durationInSeconds,
            settingsJson: settingsObjectAsJson
        };

        const responseFromBackend = await fetch(`${process.env.REACT_APP_API_URL}picnic/start`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payloadToSend)
        });
        
        if (!responseFromBackend.ok) {
            const errorData = await responseFromBackend.json();
            return { success: false, message: errorData.message || 'Error al iniciar la partida de Picnic Day.' };
        }
        
        const data = await responseFromBackend.json();
        return { success: true, data: data }; // Aquí viene el matchId
    } catch (networkError) {
        return { success: false, message: 'Error de red al intentar iniciar la partida.' };
    }
};

const StopPicnicMatchApiCall = async (activeMatchId) => {
    try {
        // Como el matchId va por [FromQuery] en C#, lo concatenamos en la URL
        const responseFromBackend = await fetch(`${process.env.REACT_APP_API_URL}picnic/stop?matchId=${activeMatchId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (!responseFromBackend.ok) {
            const errorData = await responseFromBackend.json();
            return { success: false, message: errorData.message || 'Error al detener la partida de Picnic Day.' };
        }
        
        const data = await responseFromBackend.json();
        return { success: true, data: data }; // Aquí viene el ganador calculado
    } catch (networkError) {
        return { success: false, message: 'Error de red al intentar detener la partida.' };
    }
};

/**
 * ==============================================================================
 * DATA LAYER (DL) - PICNIC FAN
 * Encargado de mandar el progreso de puntos a la API de forma silenciosa.
 * ==============================================================================
 */

const SendPicnicScoreProgressApiCall = async (matchIdentifier, playerIdentifier, currentScore) => {
    try {
        const payloadToSend = {
            matchId: matchIdentifier,
            playerId: playerIdentifier, // 'lucho' o 'tunita'
            currentScore: currentScore
        };

        const responseFromBackend = await fetch(`${process.env.REACT_APP_API_URL}picnic/progress`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payloadToSend)
        });

        // Retornamos si fue exitoso, pero no lanzamos errores agresivos 
        // para no interrumpir la experiencia del jugador si hay un micro-corte de internet.
        return responseFromBackend.ok;
    } catch (networkError) {
        // Fallo silencioso: si no hay internet en este segundo, el juego sigue,
        // y en el próximo segundo se intentará mandar de nuevo la puntuación actualizada.
        return false;
    }
};

export { PrepareScreenForPicnicApiCall, StartPicnicMatchApiCall, StopPicnicMatchApiCall, SendPicnicScoreProgressApiCall }